var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPageStart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.03947 7.70711C0.648951 7.31658 0.648951 6.68342 1.03947 6.29289L7.03947 0.292893C7.43 -0.0976317 8.06316 -0.0976318 8.45369 0.292893C8.84421 0.683417 8.84421 1.31658 8.45369 1.70711L3.16079 7L8.45369 12.2929C8.84421 12.6834 8.84421 13.3166 8.45369 13.7071C8.06316 14.0976 7.43 14.0976 7.03947 13.7071L1.03947 7.70711Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.03947 7.70711C8.64895 7.31658 8.64895 6.68342 9.03947 6.29289L15.0395 0.292893C15.43 -0.0976317 16.0632 -0.0976318 16.4537 0.292893C16.8442 0.683417 16.8442 1.31658 16.4537 1.70711L11.1608 7L16.4537 12.2929C16.8442 12.6834 16.8442 13.3166 16.4537 13.7071C16.0632 14.0976 15.43 14.0976 15.0395 13.7071L9.03947 7.70711Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageStart);
export default __webpack_public_path__ + "static/media/page_start.841937a0421d8bd3956cb0b58790c014.svg";
export { ForwardRef as ReactComponent };